import { addDisplayedEnum } from './enumCommon.js';

const Language = addDisplayedEnum(
  {
    ENGLISH: 'en',
    SPANISH: 'es',
  },
  'Language',
);

const FundingSource = addDisplayedEnum(
  {
    EMPLOYMENT_INCOME: 'employmentIncome',
    INVESTMENTS: 'investments',
    INHERITANCE: 'inheritance',
    BUSINESS_INCOME: 'businessIncome',
    SAVINGS: 'savings',
    FAMILY: 'family',
  },
  'FundingSource',
);

const ResidencyStatus = addDisplayedEnum(
  {
    CITIZEN: 'citizen',
    PERMANENT_RESIDENT: 'permanentResident',
    VISA_HOLDER: 'visaHolder',
  },
  'ResidencyStatus',
);

const makeKeyMapFromList = (list) => Object.fromEntries(list.split(',').map((item) => [item, item]));

const countryCodesList =
  'ABW,AFG,AGO,AIA,ALA,ALB,AND,ARE,ARG,ARM,ASM,ATA,ATF,ATG,AUS,AUT,AZE,BDI,BEL,BEN,BES,BFA,BGD,BGR,BHR,BHS,BIH,BLM,BLR,BLZ,BMU,BOL,BRA,BRB,BRN,BTN,BVT,BWA,CAF,CAN,CCK,CHE,CHL,CHN,CIV,CMR,COD,COG,COK,COL,COM,CPV,CRI,CUB,CUW,CXR,CYM,CYP,CZE,DEU,DJI,DMA,DNK,DOM,DZA,ECU,EGY,ERI,ESH,ESP,EST,ETH,FIN,FJI,FLK,FRA,FRO,FSM,GAB,GBR,GEO,GGY,GHA,GIB,GIN,GLP,GMB,GNB,GNQ,GRC,GRD,GRL,GTM,GUF,GUM,GUY,HKG,HMD,HND,HRV,HTI,HUN,IDN,IMN,IND,IOT,IRL,IRN,IRQ,ISL,ISR,ITA,JAM,JEY,JOR,JPN,KAZ,KEN,KGZ,KHM,KIR,KNA,KOR,KWT,LAO,LBN,LBR,LBY,LCA,LIE,LKA,LSO,LTU,LUX,LVA,MAC,MAF,MAR,MCO,MDA,MDG,MDV,MEX,MHL,MKD,MLI,MLT,MMR,MNE,MNG,MNP,MOZ,MRT,MSR,MTQ,MUS,MWI,MYS,MYT,NAM,NCL,NER,NFK,NGA,NIC,NIU,NLD,NOR,NPL,NRU,NZL,OMN,PAK,PAN,PCN,PER,PHL,PLW,PNG,POL,PRI,PRK,PRT,PRY,PSE,PYF,QAT,REU,ROU,RUS,RWA,SAU,SDN,SEN,SGP,SGS,SHN,SJM,SLB,SLE,SLV,SMR,SOM,SPM,SRB,SSD,STP,SUR,SVK,SVN,SWE,SWZ,SXM,SYC,SYR,TCA,TCD,TGO,THA,TJK,TKL,TKM,TLS,TON,TTO,TUN,TUR,TUV,TWN,TZA,UGA,UKR,UMI,URY,USA,UZB,VAT,VCT,VEN,VGB,VIR,VNM,VUT,WLF,WSM,YEM,XKX,ZAF,ZMB,ZWE';
const Country = addDisplayedEnum(makeKeyMapFromList(countryCodesList), 'Country');

const visaTypesList = 'B1,B2,E1,E2,F1,H1B,H2A,H2B,J1,L1,O1,TN';
const VisaType = addDisplayedEnum(makeKeyMapFromList(visaTypesList), 'VisaType');

const DisclosureItem = addDisplayedEnum(
  {
    IS_CONTROL_PERSON: 'isControlPerson',
    IS_AFFILIATED: 'isAffiliatedExchangeOrFinra',
    IS_PEP: 'isPoliticallyExposed',
    IS_PEP_FAMILY: 'isImmediateFamilyExposed',
  },
  'DisclosureItem',
);

const MaritalStatus = addDisplayedEnum(
  {
    SINGLE: 'single',
    MARRIED: 'married',
    DIVORCED: 'divorced',
    WIDOWED: 'widowed',
  },
  'MaritalStatus',
);

const BeneficiaryType = addDisplayedEnum(
  {
    PRIMARY: 'primary',
    BACKUP: 'backup',
  },
  'BeneficiaryType',
);

const BeneficiaryRelationship = addDisplayedEnum(
  {
    SPOUSE: 'spouse',
    OTHER: 'other',
  },
  'BeneficiaryRelationship',
);

const EmploymentStatus = addDisplayedEnum(
  {
    EMPLOYED: 'employed',
    UNEMPLOYED: 'unemployed',
    STUDENT: 'student',
    RETIRED: 'retired',
  },
  'EmploymentStatus',
);

const AccountLossRiskQuestion = addDisplayedEnum(
  {
    LOWRISK: 'lowRiskAccountLoss',
    MEDIUMRISK: 'mediumRiskAccountLoss',
    HIGHRISK: 'highRiskAccountLoss',
  },
  'AccountLossRiskQuestion',
);

const InvestmentObjectiveRiskQuestion = addDisplayedEnum(
  {
    LOWRISK: 'lowRiskInvestmentObjective',
    MEDIUMRISK: 'mediumRiskInvestmentObjective',
    HIGHRISK: 'highRiskInvestmentObjective',
  },
  'InvestmentObjectiveRiskQuestion',
);

const IncomeLevel = addDisplayedEnum(
  {
    INCOME_RANGE_0_100K: 'incomeLevel_0-100000',
    INCOME_RANGE_100K_5M: 'incomeLevel_>100000',
  },
  'IncomeLevel',
);

const NetWorth = addDisplayedEnum(
  {
    NET_WORTH_RANGE_0_100K: 'netWorth_0-100000',
    NET_WORTH_RANGE_100K_5M: 'netWorth_>100000',
  },
  'NetWorth',
);

const PayrollAdminType = addDisplayedEnum(
  {
    THIRD_PARTY: 'thirdParty',
    IN_HOUSE: 'inHouse',
  },
  'PayrollAdminType',
);

export {
  Language,
  FundingSource,
  ResidencyStatus,
  Country,
  VisaType,
  DisclosureItem,
  MaritalStatus,
  BeneficiaryType,
  BeneficiaryRelationship,
  EmploymentStatus,
  AccountLossRiskQuestion,
  InvestmentObjectiveRiskQuestion,
  IncomeLevel,
  NetWorth,
  PayrollAdminType,
};
